import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useSelector } from 'react-redux';
import { PrivilegeLevels } from '../../shared/constants/PrivilegeLevels';
import {
  trackerToolbarButtonTypographySx,
  trackerToolbarNeutralOutlineColor,
} from '../TrackerFilter/trackerFilterToolbarStyles';

const AdminCategorySelect = (props) => {
  const { category, handleCategoryChange } = props;

  const user = useSelector((state) => state.user);
  const isAdminPrivilegeProtected = user.userInfo.privilege > PrivilegeLevels.manager.level;
  const contentLogActivated = user.addonControls.contentLogActivated === true;

  return (
    <FormControl size="small" sx={{ minWidth: '220px' }}>
      <InputLabel id="contact-category" sx={{ ...trackerToolbarButtonTypographySx }}>
        Category
      </InputLabel>
      <Select
        labelId="contact-category"
        id="contact-category-select"
        data-cy="category-select-AdminCategorySelect"
        value={category}
        label="Category"
        onChange={handleCategoryChange}
        sx={{
          height: '36px',
          borderRadius: 1,
          backgroundColor: '#FFFFFF',
          ...trackerToolbarButtonTypographySx,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: trackerToolbarNeutralOutlineColor,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: '2px',
            },
          },
        }}
      >
        <MenuItem value={'Users'} sx={{ ...trackerToolbarButtonTypographySx }}>
          Users
        </MenuItem>
        <MenuItem value={'Units'} sx={{ ...trackerToolbarButtonTypographySx }}>
          Units
        </MenuItem>
        <MenuItem value={'Departments'} sx={{ ...trackerToolbarButtonTypographySx }}>
          Departments
        </MenuItem>
        <MenuItem value={'Campaigns'} sx={{ ...trackerToolbarButtonTypographySx }}>
          Campaigns
        </MenuItem>
        {contentLogActivated && (
          <MenuItem value={'Audiences'} sx={{ ...trackerToolbarButtonTypographySx }}>
            Audiences
          </MenuItem>
        )}
        {contentLogActivated && (
          <MenuItem value={'Content Types'} sx={{ ...trackerToolbarButtonTypographySx }}>
            Content Types
          </MenuItem>
        )}
        <MenuItem value={'Types'} sx={{ ...trackerToolbarButtonTypographySx }}>
          Types
        </MenuItem>
        {isAdminPrivilegeProtected && (
          <MenuItem value={'Custom Fields'} sx={{ ...trackerToolbarButtonTypographySx }}>
            Contacts Custom Fields
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default AdminCategorySelect;
